import { render, staticRenderFns } from "./factory_send.vue?vue&type=template&id=5d61ff6c"
import script from "./factory_send.vue?vue&type=script&lang=js"
export * from "./factory_send.vue?vue&type=script&lang=js"
import style0 from "./factory_send.vue?vue&type=style&index=0&id=5d61ff6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports